window.FlexBundles = window.FlexBundles || {};

// Define all custom events in one place
window.FlexBundles.EVENTS = {
  AFTER_ADD_TO_CART: "flex-bundles:after-add-to-cart",
  VARIANT_CHANGED: "flex-bundles:variant-changed",
  BUNDLE_COMPONENT_UPDATED: "flex-bundles:component-updated"
};

// Track bundle types across the page
window.FlexBundles.bundleInstances = {
  'fixed-product': [],
  'dynamic': []
};

window.FlexBundles.initBundle = (blockId) => {
  const node = document.getElementById(`flex-bundles-${blockId}`);
  if (!node) return;

  let data = JSON.parse(node.querySelector('[js-flex-bundles-data]').textContent);
  let bundleProducts = data.products;
  let parentProductData = data.parent;


  // Track bundle instances by type - hardcoded as dynamic
  let bundleType = 'dynamic';

  if (bundleType && window.FlexBundles.bundleInstances[bundleType]) {
    window.FlexBundles.bundleInstances[bundleType].push(blockId);
    
    // Check for multiple fixed bundles on the page
    if (bundleType === 'fixed-product' && window.FlexBundles.bundleInstances['fixed-product'].length > 1) {
      console.warn('Multiple fixed bundles detected on the page. Only one fixed bundle is recommended.');
      alert('Multiple fixed bundles detected on the page. This may cause unexpected behavior.');
    }

    // Check for multiple dynamic bundles on the page
    if (bundleType === 'dynamic' && window.FlexBundles.bundleInstances['dynamic'].length > 1) {
      console.warn('Multiple dynamic bundles detected on the page. Only one dynamic bundle is recommended.');
      alert('Multiple dynamic bundles detected on the page. This may cause unexpected behavior.');
    }
  }

  /**
   * Data structure overview:
   * - bundleProducts: Object mapping product IDs to product objects
   *   Each product object contains product data (title, handle, etc) and a variants array
   * - bundleConfig: Configuration for the bundle (components, settings, etc)
   * - parentProductData: Data for the parent product that contains this bundle
   */

  // Utility for safely accessing product variants
  const getVariants = productId => (bundleProducts[productId]?.variants || []);

  // Helper functions for price calculations
  function toDollars(cents) {
    return (cents / 100).toFixed(2);
  }

  function formatMoney(dollars) {
    return "$" + parseFloat(dollars).toFixed(2);
  }

  // Create a global state object to track selected variants and their prices
  const bundleState = {
    selectedVariants: {},
    quantityInputs: {}, // Cache for quantity inputs

    // Cache a quantity input for a component
    cacheQuantityInput(componentId, input) {
      this.quantityInputs[componentId] = input;
    },

    setVariant(componentId, variant, quantity) {
      if (!variant) {
        console.error('Attempted to set invalid variant for component:', componentId);
        return;
      }

      // Ensure product_id is set
      if (!variant.product_id) {
        console.warn('Variant without product_id for component:', componentId);
        variant.product_id = componentId.split('_')[0];
      }

      // For dynamic bundles, always use passed quantity
      variant.quantity = quantity || 1;

      this.selectedVariants[componentId] = variant;
    },

    // Get the currently selected variant for a product
    getVariant(productId) {
      return this.selectedVariants[productId];
    },

    // Calculate bundle prices - simple logic: 5 items = 15% off
    calculatePrices() {
      let originalPriceCents = 0;

      // Sum up prices of all selected variants
      Object.values(this.selectedVariants).forEach((variant) => {
        if (variant && variant.price) {
          const quantity = variant.quantity || 1;
          originalPriceCents += Math.round(variant.price) * quantity;
        }
      });

      // Apply 15% discount if total quantity is 5 or more
      const totalQuantity = Object.values(this.selectedVariants).reduce(
        (total, variant) => total + (variant?.quantity || 0), 0
      );

      console.log('Total quantity:', totalQuantity, 'Selected variants:', this.selectedVariants);

      const discountedPriceCents = totalQuantity >= 5
        ? Math.round(originalPriceCents * 0.85) // 15% off
        : originalPriceCents;

      // Calculate savings
      const savingsAmountCents = originalPriceCents - discountedPriceCents;
      const savingsPercentage = totalQuantity >= 5 ? 15 : 0;

      return {
        original: toDollars(originalPriceCents),
        discounted: toDollars(discountedPriceCents),
        savingsAmount: toDollars(savingsAmountCents),
        savingsPercentage,
      };
    },

    // Initialize with default variants - simplified for dynamic bundles
    initialize() {
      // No initialization needed for dynamic bundles
      // Products are added when user toggles them on
    },
  };

  // Update the bundle summary items
  function updateBundleSummary() {
    // Cache DOM elements
    const elements = {
      container: node.querySelector("[js-flex-bundles-summary-items]"),
      subtotalRow: node.querySelector("[js-flex-bundles-summary-subtotal-row]"),
      subtotal: node.querySelector("[js-flex-bundles-summary-subtotal]"),
      discountRow: node.querySelector("[js-flex-bundles-summary-discount-row]"),
      discountLabel: node.querySelector("[js-flex-bundles-discount-label]"),
      discount: node.querySelector("[js-flex-bundles-summary-discount]"),
      total: node.querySelector("[js-flex-bundles-summary-total]")
    };

    if (!elements.container) return;

    // Clear existing content
    elements.container.innerHTML = "";
    elements.container.dataset.empty = Object.keys(bundleState.selectedVariants).length === 0 ? "true" : "false";

    // Get selected variants from state
    const selectedVariants = bundleState.selectedVariants;
    if (!Object.keys(selectedVariants).length) return;

    // Build summary items HTML - simple logic, no per-item discounts
    const summaryEntries = Object.entries(bundleState.selectedVariants);

    const summaryItems = summaryEntries
      .map(([componentId, variant]) => {
        if (!variant) return null;

        // Get product ID from variant or component ID
        const productId = variant.product_id || componentId.split('_')[0];
        // Get product data
        const productData = bundleProducts[productId] || {};
        // Get the product title from product data, variant name, or fallback
        const productTitle = productData.title || variant.name?.split(' - ')[0] || "Product";
        const quantity = variant.quantity || 1;

        // Get variant info
        const variantInfo = variant.public_title === "Default Title" ? "" : variant.public_title;

        // Simple price calculation - no per-item discount display
        const itemPrice = variant.price * quantity;

        // Build item HTML
        return `
          <div class="flex-bundles__summary-item">
            <div class="flex-bundles__summary-item-title">
              ${productTitle} × ${quantity}
              ${variantInfo ? `<div class="flex-bundles__summary-item-variant">${variantInfo}</div>` : ""}
            </div>
            <div class="flex-bundles__summary-item-price">
              ${formatMoney(itemPrice / 100)}
            </div>
            <div class="flex-bundles__summary-item-remove">
              <button class="flex-bundles__summary-item-remove-button" js-flex-bundles-summary-item-remove data-component-id="${componentId}">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Pro v7.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M232.2 68.8C236.9 56.3 248.8 48 262.2 48L377.8 48C391.1 48 403.1 56.3 407.8 68.8L424 112L520 112C533.3 112 544 122.7 544 136C544 149.3 533.3 160 520 160L120 160C106.7 160 96 149.3 96 136C96 122.7 106.7 112 120 112L216 112L232.2 68.8zM147.6 516.8L124.7 208L172.9 208L195.5 513.2C196.1 521.6 203.1 528 211.5 528L428.6 528C437 528 443.9 521.5 444.6 513.2L467.2 208L515.3 208L492.4 516.7C489.9 550.1 462.1 576 428.6 576L211.5 576C178 576 150.2 550.1 147.7 516.7z"/></svg>
              </button>
            </div>
          </div>
        `;
      })
      .filter(Boolean)
      .join("");

    // Update summary items
    elements.container.innerHTML = summaryItems;

    // Get price calculations
    const prices = bundleState.calculatePrices();

    // Update subtotal
    if (elements.subtotal) {
      elements.subtotal.textContent = formatMoney(prices.original);
    }

    // Simple discount display logic
    const hasDiscount = parseFloat(prices.savingsAmount) > 0;

    // Always show subtotal row
    if (elements.subtotalRow) {
      elements.subtotalRow.style.display = "flex";
    }

    // Update discount row - show if 5+ products selected
    if (elements.discountRow) {
      if (hasDiscount) {
        elements.discountRow.style.display = "flex";

        if (elements.discountLabel) {
          elements.discountLabel.textContent = "Discount (15%)";
        }

        if (elements.discount) {
          elements.discount.textContent = `-${formatMoney(prices.savingsAmount)}`;
        }
      } else {
        elements.discountRow.style.display = "none";
      }
    }

    // Update total
    if (elements.total) {
      elements.total.textContent = formatMoney(prices.discounted);
    }
  }

  // Placeholder for removed functions - these were limiting bundle toggles and quantity inputs

  // Update the progress bar based on selected items
  function updateProgressBar() {
    const progressBarContainer = node.querySelector("[js-flex-bundles-progress-bar-container]");
    const progressBarLabel = node.querySelector("[js-flex-bundles-progress-bar-label-text]");
    const progressBarFill = node.querySelector("[js-flex-bundles-progress-bar-fill]");

    if (!progressBarContainer || !progressBarLabel || !progressBarFill) return;

    // Count total quantities (not just number of products)
    const totalQuantity = Object.values(bundleState.selectedVariants).reduce(
      (total, variant) => total + (variant?.quantity || 0), 0
    );
    const targetCount = 5; // Hardcoded target

    // Calculate progress percentage (capped at 100%)
    const progressPercentage = Math.min((totalQuantity / targetCount) * 100, 100);

    // Update progress bar fill
    progressBarFill.style.width = `${progressPercentage}%`;

    // Update progress bar label
    if (totalQuantity >= targetCount) {
      progressBarLabel.textContent = `🎉 You've unlocked 15% off!`;
    } else {
      const remaining = targetCount - totalQuantity;
      const itemText = remaining === 1 ? 'item' : 'items';
      progressBarLabel.textContent = `Just ${remaining} more ${itemText} to unlock 15% off!`;
    }

    // Show/hide progress bar based on whether any items are selected
    const hasItems = totalQuantity > 0;
    progressBarContainer.style.display = hasItems ? 'block' : 'none';
  }

  // Update all price displays on the page
  function updatePriceDisplays() {
    const prices = bundleState.calculatePrices();

    // Update original price elements
    node.querySelectorAll("[js-flex-bundles-original-price]").forEach((el) => {
      el.style.display = "inline";
      el.textContent = formatMoney(prices.original);
    });

    // Update discounted price elements
    node.querySelectorAll("[js-flex-bundles-discounted-price]").forEach((el) => {
      el.textContent = formatMoney(prices.discounted);
    });

    // Update savings elements - simple logic
    node.querySelectorAll("[js-flex-bundles-savings]").forEach((el) => {
      if (prices.savingsPercentage > 0) {
        el.textContent = `Save ${prices.savingsPercentage}%`;
      } else {
        el.textContent = "";
      }
    });

    // Update the bundle summary
    updateBundleSummary();

    // Update the progress bar
    updateProgressBar();
  }

  const FlexBundlesProduct = `flex-bundles-product`;
  const FlexBundlesVariantSelects = `flex-bundles-variant-selects`;
  const FlexBundlesForm = `flex-bundles-form`;

  // manages the overall product state and ui
  if (!customElements.get(FlexBundlesProduct)) {
    customElements.define(
      FlexBundlesProduct,
      class extends HTMLElement {
        constructor() {
          super();
          // Store product and component IDs for state management
          this.productId = this.dataset.productId;
          this.componentId = this.dataset.componentId;
          
          // Get product data and variants
          this.productData = bundleProducts[this.productId] || {};
          this.variantData = getVariants(this.productId);
          
          // Cache DOM elements for better performance
          this.variantSelects = this.querySelector(FlexBundlesVariantSelects);
          this.priceElement = this.querySelector("[js-flex-bundles-product-price-discounted]");
          this.priceOriginalElement = this.querySelector("[js-flex-bundles-product-price-original]");
          this.productImage = this.querySelector("[js-flex-bundles-product-image] img");
          this.bundleToggle = this.querySelector("[js-flex-bundles-component-bundle-toggle]");
          this.quantityInput = this.querySelector(`input[name="flex-bundles-component-quantity[${this.productId}]"]`);
          
          // Cache form elements for dynamic bundle validation
          this.form = this.closest(FlexBundlesForm);
          this.submitButton = this.form?.querySelector("[js-flex-bundles-add-to-cart]");
          
          // Cache the quantity input in bundleState
          if (this.quantityInput) {
            bundleState.cacheQuantityInput(this.componentId, this.quantityInput);
          }

          // Get initial quantity and discount from bundle config
          const { quantity, discount } = this.getComponentConfig();
          
          // Initialize with the first variant if available
          if (this.variantData?.length > 0) {
            const firstVariant = this.variantData.find(v => v.available) || this.variantData[0];
            // Set initial quantity and discount
            firstVariant.quantity = quantity;
            firstVariant.discount = discount;
            // Store product_id in the variant for easier reference
            firstVariant.product_id = this.productId;

            // Update price display with initial values
            if (this.priceElement && firstVariant.price) {
              this.updatePriceDisplay(firstVariant, discount);
            }

            // Update bundle state if component is initially selected
            if (this.bundleToggle?.checked) {
              const quantity = this.quantityInput ? parseInt(this.quantityInput.value, 10) : 1;
              bundleState.setVariant(this.componentId, firstVariant, quantity);
              updatePriceDisplays();

              // Dispatch product updated event
              this.dispatchEvent(new CustomEvent(FlexBundles.EVENTS.BUNDLE_COMPONENT_UPDATED));
            }
          }

          // Add a flag to track if we're handling a toggle change
          this.isHandlingToggle = false;

          // Bind methods
          this.onVariantChanged = this.onVariantChanged.bind(this);
        }

        getComponentConfig() {
          // Simplified for dynamic bundles
          return { quantity: 1, discount: 0 };
        }

        connectedCallback() {
          // Listen for variant changes
          this.addEventListener(FlexBundles.EVENTS.VARIANT_CHANGED, this.onVariantChanged);

          // Listen for quantity changes
          if (this.quantityInput) {
            this.quantityInput.addEventListener("change", this.onQuantityChanged);
          }

          // Listen for bundle toggle changes
          if (this.bundleToggle) {
            this.bundleToggle.addEventListener("change", this.onBundleToggleChanged);
          }
        }

        disconnectedCallback() {
          // Remove event listeners
          this.removeEventListener(FlexBundles.EVENTS.VARIANT_CHANGED, this.onVariantChanged);
          if (this.quantityInput) {
            this.quantityInput.removeEventListener("change", this.onQuantityChanged);
          }
          if (this.bundleToggle) {
            this.bundleToggle.removeEventListener("change", this.onBundleToggleChanged);
          }
        }

        onVariantChanged(event) {
          const variant = event.detail.variant;
          if (!variant) return;

          // Add product_id to variant for easier reference
          variant.product_id = this.productId;

          // Update price display
          if (this.priceElement) {
            const { discount } = this.getComponentConfig();
            this.updatePriceDisplay(variant, discount);
          }

          // Update product image if available
          if (this.productImage && variant.featured_image) {
            this.productImage.src = variant.featured_image.src;
            if (this.productImage.srcset) {
              const currentSrcset = this.productImage.srcset;
              const baseImageUrl = variant.featured_image.src.split('?')[0];
              const newSrcset = currentSrcset.replace(/([^?]*)\?[^ ]*/g, `${baseImageUrl}?`);
              this.productImage.srcset = newSrcset;
            }
          } else if (this.productImage) {
            // Try to get product image from product data if variant doesn't have one
            if (this.productData.featured_image) {
              this.productImage.src = this.productData.featured_image.src;
            }
          }

          // Only update bundle state if component is selected
          if (this.bundleToggle?.checked) {
            const quantity = this.quantityInput ? parseInt(this.quantityInput.value, 10) : 1;
            bundleState.setVariant(this.componentId, variant, quantity);
            updatePriceDisplays();
          }

          event.stopPropagation();
        }

        onQuantityChanged = (event) => {
          // Always allow quantity changes in dynamic bundles
          const quantity = parseInt(event.target.value);
          if (isNaN(quantity) || quantity < 1) return;

          const variant = bundleState.selectedVariants[this.componentId];
          if (variant && this.bundleToggle?.checked) {
            bundleState.setVariant(this.componentId, variant, quantity);
            updatePriceDisplays();

            // Dispatch product updated event to trigger validation
            const productUpdatedEvent = new CustomEvent(FlexBundles.EVENTS.BUNDLE_COMPONENT_UPDATED, {
              bubbles: true,
              composed: true
            });
            this.dispatchEvent(productUpdatedEvent);
          }
        };

        onBundleToggleChanged = (event) => {
          const isChecked = event.target.checked;
          const variant = this.variantSelects?.getSelectedVariant();

          // Single path for updating bundle state
          if (isChecked && variant) {
            // Make sure product_id is set
            variant.product_id = this.productId;
            
            // Get quantity from input for dynamic bundles
            let quantity = 1;
            if (this.quantityInput) {
              quantity = parseInt(this.quantityInput.value, 10) || 1;
            }
            
            bundleState.setVariant(this.componentId, variant, quantity);
          } else {
            delete bundleState.selectedVariants[this.componentId];
          }

          // Single update call that handles everything
          updatePriceDisplays(); // This already calls updateBundleSummary internally

          // Dispatch product updated event
          const productUpdatedEvent = new CustomEvent(FlexBundles.EVENTS.BUNDLE_COMPONENT_UPDATED, {
            bubbles: true,
            composed: true
          });
          this.dispatchEvent(productUpdatedEvent);
        };

        updatePriceDisplay(variant, discount = 0) {
          if (!variant?.price) return;

          // Simple price display - no per-product discounts
          if (this.priceElement) {
            this.priceElement.textContent = formatMoney(variant.price / 100);
          }

          // No per-product discount display
          if (this.priceOriginalElement) {
            this.priceOriginalElement.textContent = "";
          }
        }
      }
    );
  }

  // handles variant selection ui and availability
  if (!customElements.get(FlexBundlesVariantSelects)) {
    customElements.define(
      FlexBundlesVariantSelects,
      class extends HTMLElement {
        constructor() {
          super();
          this.productId = this.dataset.productId;
          this.componentId = this.dataset.componentId;
          this.variantData = getVariants(this.productId);
          this.optionInputs = this.querySelectorAll("[js-flex-bundles-variant-option]");
          this.bundleToggle = this.querySelector("[js-flex-bundles-component-bundle-toggle]");
          this.fieldsets = this.querySelectorAll("[js-flex-bundles-option-fieldset]");
          
          // Cache option positions
          this.optionPositions = [...new Set(
            Array.from(this.optionInputs).map(input => 
              parseInt(input.dataset.optionPosition)
            )
          )];

          // Bind methods once to avoid creating new functions on each event
          this.onToggleChange = this.onToggleChange.bind(this);
          this.onVariantChange = this.onVariantChange.bind(this);
          this.onProductReady = this.onProductReady.bind(this);
        }

        connectedCallback() {
          // Set up event listeners - always for dynamic bundles
          if (this.bundleToggle) {
            this.bundleToggle.addEventListener("change", this.onToggleChange);
          }
          this.addEventListener("change", this.onVariantChange);
          this.addEventListener('product:ready', this.onProductReady);

          // Add keyboard navigation
          this.addEventListener('keydown', this.handleKeyNavigation);

          // Initialize with first available variant
          this.initializeWithFirstVariant();
        }

        disconnectedCallback() {
          // Clean up event listeners
          if (this.bundleToggle) {
            this.bundleToggle.removeEventListener("change", this.onToggleChange);
          }
          this.removeEventListener("change", this.onVariantChange);
          this.removeEventListener('product:ready', this.onProductReady);
          this.removeEventListener('keydown', this.handleKeyNavigation);
        }

        onProductReady(event) {
          // Update variant data if provided
          if (event.detail.variantData) {
            this.variantData = event.detail.variantData;
            this.initializeWithFirstVariant();
          }
        }

        initializeWithFirstVariant() {
          const firstVariant = this.variantData.find(v => v.available) || this.variantData[0];
          if (firstVariant) {
            this.initializeWithVariant(firstVariant);
          }
        }

        /**
         * Initializes the component with a specific variant
         * @param {Object} variant - The variant to initialize with
         */
        initializeWithVariant(variant) {
          if (!variant) return;
          
          // Set initial options
          const options = variant.options;
          this.optionInputs.forEach(input => {
            const position = parseInt(input.dataset.optionPosition) - 1;
            if (options[position] === input.value) {
              input.checked = true;
            }
          });

          // Update option legends
          this.updateOptionLegends(options);
          // Update option availability
          this.updateOptionsAvailability();
        }

        /**
         * Handles changes to the bundle toggle (for dynamic bundles)
         * @param {Event} event - The change event from the toggle
         */
        onToggleChange(event) {
          const isChecked = event.target.checked;
          const variant = this.getSelectedVariant();
          
          if (!isChecked || !variant) {
            delete bundleState.selectedVariants[this.componentId];
            updatePriceDisplays();
            return;
          }

          // Set product_id for easier reference
          variant.product_id = this.productId;
          
          // Get current quantity for dynamic bundles
          let quantity = 1;
          const quantityInput = bundleState.quantityInputs[this.componentId];
          quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
          
          // Update bundle state and notify parent
          bundleState.setVariant(this.componentId, variant, quantity);
          this.dispatchVariantChanged(variant);
        }

        /**
         * Handles changes to variant options
         */
        onVariantChange() {
          const variant = this.getSelectedVariant();
          if (!variant) return;

          // Update UI and state
          this.updateOptionLegends(variant.options);
          this.updateOptionsAvailability();
          
          // Notify parent of change
          this.dispatchVariantChanged(variant);
        }

        /**
         * Gets the currently selected variant
         * @returns {Object|null} The selected variant or null
         */
        getSelectedVariant() {
          const selectedOptions = this.getSelectedOptions();
          return this.variantData.find(variant => 
            variant.available && 
            selectedOptions.every((option, index) => option === variant.options[index])
          );
        }

        /**
         * Gets the currently selected options
         * @returns {Array<string>} Array of selected option values
         */
        getSelectedOptions() {
          return Array.from(this.optionInputs)
            .filter(input => input.checked)
            .map(input => ({
              position: parseInt(input.dataset.optionPosition) - 1,
              value: input.value
            }))
            .sort((a, b) => a.position - b.position)
            .map(option => option.value);
        }

        /**
         * Updates which options are available based on current selection
         */
        updateOptionsAvailability() {
          const selectedOptions = this.getSelectedOptions();

          this.optionPositions.forEach(position => {
            const testOptions = [...selectedOptions];
            const optionInputsForPosition = Array.from(this.optionInputs)
              .filter(input => parseInt(input.dataset.optionPosition) === position);

            optionInputsForPosition.forEach(input => {
              testOptions[position - 1] = input.value;
              const isAvailable = this.variantData.some(variant => 
                variant.available && 
                testOptions.every((option, index) => 
                  option === undefined || option === variant.options[index]
                )
              );

              const label = input.nextElementSibling;
              input.disabled = !isAvailable;
              input.classList.toggle("disabled", !isAvailable);
              label?.classList.toggle("disabled", !isAvailable);

              // Add accessibility attributes
              input.setAttribute('aria-disabled', !isAvailable);
              if (!isAvailable) {
                input.setAttribute('aria-label', `${input.value} - Not available`);
              } else {
                input.removeAttribute('aria-label');
              }
            });
          });
        }

        /**
         * Updates the option legends with selected values
         * @param {Array<string>} selectedOptions - Array of selected option values
         */
        updateOptionLegends(selectedOptions) {
          this.fieldsets.forEach((fieldset, index) => {
            const optionValue = fieldset.querySelector("[js-flex-bundles-variant-option-value]");
            if (optionValue && selectedOptions[index]) {
              optionValue.textContent = selectedOptions[index];
            }
          });
        }

        /**
         * Dispatches a variant changed event
         * @param {Object} variant - The variant that changed
         */
        dispatchVariantChanged(variant) {
          this.dispatchEvent(new CustomEvent(FlexBundles.EVENTS.VARIANT_CHANGED, {
            bubbles: true,
            detail: { variant }
          }));
        }

        handleKeyNavigation(event) {
          const { key } = event;
          const currentInput = document.activeElement;
          
          if (!currentInput.matches('[js-flex-bundles-variant-option]')) return;

          const currentPosition = parseInt(currentInput.dataset.optionPosition);
          const currentOptions = Array.from(this.optionInputs)
            .filter(input => parseInt(input.dataset.optionPosition) === currentPosition);

          const currentIndex = currentOptions.indexOf(currentInput);

          switch (key) {
            case 'ArrowLeft':
              event.preventDefault();
              if (currentIndex > 0) {
                currentOptions[currentIndex - 1].focus();
              }
              break;
            case 'ArrowRight':
              event.preventDefault();
              if (currentIndex < currentOptions.length - 1) {
                currentOptions[currentIndex + 1].focus();
              }
              break;
            case 'ArrowUp':
              event.preventDefault();
              const prevPosition = currentPosition - 1;
              if (prevPosition > 0) {
                const prevOptions = Array.from(this.optionInputs)
                  .filter(input => parseInt(input.dataset.optionPosition) === prevPosition);
                if (prevOptions.length) {
                  prevOptions[0].focus();
                }
              }
              break;
            case 'ArrowDown':
              event.preventDefault();
              const nextPosition = currentPosition + 1;
              const nextOptions = Array.from(this.optionInputs)
                .filter(input => parseInt(input.dataset.optionPosition) === nextPosition);
              if (nextOptions.length) {
                nextOptions[0].focus();
              }
              break;
          }
        }
      }
    );
  }

  if (!customElements.get(FlexBundlesForm)) {
    customElements.define(
      FlexBundlesForm,
      class extends HTMLElement {
        constructor() {
          super();
          this.form = this.querySelector("form");
          this.submitButton = this.querySelector("[js-flex-bundles-add-to-cart]");
          this.originalButtonText = this.submitButton?.querySelector("span")?.textContent || "Add to Cart";
          this.blockId = this.dataset.blockId;
          // Always dynamic bundles
          this.isFixed = false;
          if (this.isFixed) {
            this.bundleProducts = Array.from(this.querySelectorAll("[js-flex-bundles-product]"));
          }

          // Bind methods once
          this.handleSubmit = this.handleSubmit.bind(this);
          this.checkAllProductsAvailability = this.checkAllProductsAvailability.bind(this);
          this.onProductUpdated = this.onProductUpdated.bind(this);
          this.validateDynamicBundleRequirements = this.validateDynamicBundleRequirements.bind(this);
        }

        connectedCallback() {
          // Set up event listeners
          if (this.form) {
            this.form.addEventListener("submit", this.handleSubmit, { capture: true });
          }

          this.addEventListener(FlexBundles.EVENTS.BUNDLE_COMPONENT_UPDATED, this.onProductUpdated);

          if (this.isFixed) {
            this.checkAllProductsAvailability();
          }
        }

        disconnectedCallback() {
          // Clean up event listeners
          if (this.form) {
            this.form.removeEventListener("submit", this.handleSubmit, { capture: true });
          }
          this.removeEventListener(FlexBundles.EVENTS.BUNDLE_COMPONENT_UPDATED, this.onProductUpdated);
        }

        /**
         * Handles product update events
         * @param {Event} event - The product updated event
         */
        onProductUpdated(event) {
          updatePriceDisplays();
          this.checkAllProductsAvailability();
          this.validateDynamicBundleRequirements();
        }

        /**
         * Validates the bundle state
         * @returns {Object} Validation result with isValid and error message
         */
        validateBundleState() {
          const selectedVariants = bundleState.selectedVariants;
          
          if (!Object.keys(selectedVariants).length) {
            return { isValid: false, error: "No products selected" };
          }

          // Validate all selected variants
          for (const [componentId, variant] of Object.entries(selectedVariants)) {
            if (!variant) {
              return { isValid: false, error: `Missing variant for component ${componentId}` };
            }

            if (!variant.available) {
              return { isValid: false, error: `Selected variant for component ${componentId} is not available` };
            }

            if (!variant.quantity || variant.quantity < 1) {
              return { isValid: false, error: `Invalid quantity for component ${componentId}` };
            }
          }

          return { isValid: true };
        }

        /**
         * Handles form submission
         * @param {Event} event - The submit event
         */
        handleSubmit(event) {
          event.preventDefault();
          if (this.submitButton.disabled) return;

          // Update button state
          updateButtonState(this.submitButton, {
            text: "Adding...",
            loading: true,
            disabled: true,
          });

          const validation = this.validateBundleState();

          if (!validation.isValid) {
            console.error("Bundle validation failed:", validation.error);
            updateButtonState(this.submitButton, {
              text: validation.error,
              loading: false,
              disabled: true,
            });
            return;
          }

          try {
            // Get selected variants from bundleState
            const selectedVariants = Object.entries(bundleState.selectedVariants).map(([componentId, variant]) => {
              const productId = variant.product_id;
              const productData = bundleProducts[productId] || {};
              
              return {
                id: variant.id,
                quantity: variant.quantity || 1,
                variantData: variant,
                productData: productData
              };
            });

            // Prepare cart properties
            // Calculate if discount should be applied (5+ total items)
            const totalQuantity = selectedVariants.reduce(
              (total, variant) => total + (parseInt(variant.quantity) || 0), 0
            );
            const shouldApplyDiscount = totalQuantity >= 5;

            const properties = {
              _components: JSON.stringify(selectedVariants.map((variant) => {
                const componentItem = {
                  id: parseInt(variant.id)
                };

                // Apply 15% discount to individual item prices if 5+ items total
                const originalPrice = variant.variantData.price / 100;
                componentItem.price = shouldApplyDiscount
                  ? originalPrice * 0.85  // 15% off
                  : originalPrice;

                // Always include quantity for dynamic bundles
                componentItem.quantity = parseInt(variant.quantity);

                componentItem.attributes = {
                  'RetailPrice': `$${originalPrice}`,
                  'Savings': shouldApplyDiscount ? `$${(originalPrice - componentItem.price).toFixed(2)}` : '0'
                };

                return componentItem;
              })),
            };

            // Add line item properties for bundle details
            const prices = bundleState.calculatePrices();

            // Add retail price
            properties['Retail Price'] = formatMoney(prices.original);

            // Add savings if applicable
            if (prices.savingsPercentage > 0) {
              properties['Savings'] = `${prices.savingsPercentage}%`;
            }

            // Add each selected item
            selectedVariants.forEach((variant, index) => {
              const productTitle = variant.productData?.title || 'Product';
              const variantTitle = variant.variantData?.title || variant.variantData?.public_title;
              const displayTitle = variantTitle && variantTitle !== 'Default Title'
                ? `${productTitle} - ${variantTitle}`
                : productTitle;

              properties[`Item ${index + 1}`] = `${displayTitle} × ${variant.quantity || 1}`;
            });

            // Submit to cart
            handleAddToCart(
              {
                items: [
                  {
                    id: parentProductData.id,
                    quantity: 1,
                    properties,
                  },
                ],
              },
              {
                onSuccess: (data) => {
                  updateButtonState(this.submitButton, {
                    text: "Added!",
                    loading: false,
                    disabled: false,
                  });

                  document.dispatchEvent(
                    new CustomEvent(FlexBundles.EVENTS.AFTER_ADD_TO_CART, {
                      detail: { cartData: data },
                    }),
                  );

                  // Reset button after delay
                  setTimeout(() => {
                    updateButtonState(this.submitButton, {
                      text: this.originalButtonText,
                      loading: false,
                      disabled: false,
                    });
                  }, 2000);
                },
                onError: (errorText) => {
                  updateButtonState(this.submitButton, {
                    text: errorText,
                    loading: false,
                    disabled: false,
                  });
                },
              },
            );
          } catch (error) {
            console.error("Error submitting form:", error);
            updateButtonState(this.submitButton, {
              text: "Error - Try Again",
              loading: false,
              disabled: false,
            });
          }
        }

        /**
         * Checks if all products in a fixed bundle are available
         * @returns {boolean} Whether all products are available
         */
        checkAllProductsAvailability() {
          if (!this.isFixed) return true;

          // Calculate total quantity across all selected products
          const totalQuantity = Object.values(bundleState.selectedVariants).reduce(
            (total, variant) => total + (variant?.quantity || 0), 0
          );

          // Check if bundle exceeds 5 items
          const exceedsQuantityLimit = totalQuantity > 5;
          
          // Find quantity limit message element
          let quantityLimitElement = this.querySelector("[js-flex-bundles-quantity-limit]");

          if (exceedsQuantityLimit && quantityLimitElement) {
            quantityLimitElement.style.display = "block";
          } else if (quantityLimitElement) {
            quantityLimitElement.style.display = "none";
          }

          let allAvailable = true;
          this.bundleProducts.forEach((product) => {
            const variant = bundleState.getVariant(product.dataset.componentId);
            if (variant && !variant.available) {
              allAvailable = false;
            }
          });

          const shouldDisable = !allAvailable || exceedsQuantityLimit;
          
          updateButtonState(this.submitButton, {
            text: this.originalButtonText,
            loading: false,
            disabled: shouldDisable,
          });

          return allAvailable && !exceedsQuantityLimit;
        }

        /**
         * Validates dynamic bundle requirements
         * @returns {boolean} Whether the bundle requirements are met
         */
        validateDynamicBundleRequirements() {
          if (!this.submitButton) {
            return true;
          }

          // Calculate total quantity across all selected products
          const totalQuantity = Object.values(bundleState.selectedVariants).reduce(
            (total, variant) => total + (variant?.quantity || 0), 0
          );

          // Check if bundle has less than 5 total items or exceeds 5 items total
          const belowMinimumItems = totalQuantity < 5;
          const exceedsQuantityLimit = totalQuantity > 5;
          
          // Find or create quantity limit message element
          let quantityLimitElement = this.querySelector("[js-flex-bundles-quantity-limit]");
          if (!quantityLimitElement && this.submitButton) {
            quantityLimitElement = document.createElement("div");
            quantityLimitElement.setAttribute("js-flex-bundles-quantity-limit", "");
            quantityLimitElement.style.fontSize = "16px";
            quantityLimitElement.style.marginTop = "12px";
            quantityLimitElement.style.textAlign = "center";
            quantityLimitElement.style.color = "#ffffff";
            quantityLimitElement.style.backgroundColor = "#007190";
            quantityLimitElement.style.fontWeight = "bold";
            quantityLimitElement.style.border = "1px solid #007190";
            quantityLimitElement.style.padding = "16px";
            this.submitButton.parentElement.appendChild(quantityLimitElement);
          }

          if (belowMinimumItems && quantityLimitElement) {
            quantityLimitElement.textContent = `Please add at least 5 items (${totalQuantity} selected)`;
            quantityLimitElement.style.display = "block";
          } else if (exceedsQuantityLimit && quantityLimitElement) {
            quantityLimitElement.textContent = "Bundle must contain exactly 5 items";
            quantityLimitElement.style.display = "block";
          } else if (quantityLimitElement) {
            quantityLimitElement.style.display = "none";
          }

          let isValid = !belowMinimumItems && !exceedsQuantityLimit;

          // No step requirements for simplified version

          this.submitButton.disabled = !isValid || belowMinimumItems || exceedsQuantityLimit;

          return isValid;
        }
      }
    );
  }

  // Add these helper functions near the top with other helpers
  function handleAddToCart(body, callbacks) {

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
      },
      body: JSON.stringify(body),
    })
      .then((response) => {
        if (!response.ok)
          throw new Error(`HTTP error! Status: ${response.status}`);
        return response.json();
      })
      .then((data) => {
        if (data.status) {
          console.error("Error adding products to cart:", data.description);
          callbacks.onError("Error - Try Again");
        } else {
          callbacks.onSuccess(data);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        callbacks.onError("Error - Try Again");
      });
  }

  function updateButtonState(button, { text, loading, disabled }) {
    const span = button.querySelector("span");
    if (span) span.textContent = text;

    button.disabled = disabled;
    button.setAttribute("data-loading", loading.toString());
    button.setAttribute("aria-disabled", disabled.toString());
  }


  // Initialize immediately since script is at bottom of template
  bundleState.initialize();
  
  // Add event delegation for remove buttons (only needs to be set up once)
  const summaryContainer = node.querySelector("[js-flex-bundles-summary-items]");
  if (summaryContainer) {
    summaryContainer.addEventListener("click", (event) => {
      const removeButton = event.target.closest("[js-flex-bundles-summary-item-remove]");
      if (!removeButton) return;
      
      event.preventDefault();
      
      // Get the component ID directly from the button
      const componentIdToRemove = removeButton.dataset.componentId;
      if (!componentIdToRemove) return;
      
      // Find the corresponding bundle toggle and uncheck it
      const bundleToggle = node.querySelector(`[js-flex-bundles-component-bundle-toggle][data-component-id="${componentIdToRemove}"]`);
      if (bundleToggle) {
        bundleToggle.checked = false;
        bundleToggle.dispatchEvent(new Event("change", { bubbles: true }));
      }
      
      // Remove from bundle state
      delete bundleState.selectedVariants[componentIdToRemove];
      
      // Update UI
      updatePriceDisplays();
    });
  }

  // Add event delegation for summary close button
  const summaryCloseButton = node.querySelector("[js-flex-bundles-summary-close]");
  if (summaryCloseButton) {
    summaryCloseButton.addEventListener("click", (event) => {
      event.preventDefault();
      
      // Toggle visibility of summary sections
      const summaryItems = node.querySelector("[js-flex-bundles-summary-items]");
      const summaryTotals = node.querySelector("[js-flex-bundles-summary-totals]");
      
      if (summaryItems && summaryTotals) {
        const isHidden = summaryItems.style.display === "none";
        
        // Toggle visibility
        summaryItems.style.display = isHidden ? "" : "none";
        summaryTotals.style.display = isHidden ? "" : "none";
        
        // Rotate close button
        summaryCloseButton.style.transform = isHidden ? "" : "rotate(180deg)";
      }
    });
  }
  
  updatePriceDisplays();
  updateBundleSummary();
  updateProgressBar();

  return () => {
    // Remove event listeners if needed
    node.querySelectorAll("[js-flex-bundles-product]").forEach((product) => {
      product.removeEventListener("variant:changed", product.onVariantChanged);
    });
    // Clear state
    bundleState.selectedVariants = {};
  };
};

if (!customElements.get("flex-bundles-quantity-input")) {
  customElements.define(
    "flex-bundles-quantity-input",
    class extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector("input");
        this.changeEvent = new Event("change", { bubbles: true });

        // Add event listeners
        this.input.addEventListener("change", this.onInputChange.bind(this));
        this.querySelectorAll("button").forEach((button) =>
          button.addEventListener("click", this.onButtonClick.bind(this)),
        );
      }

      // Handle button clicks (plus/minus)
      onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;

        event.target.name === "plus"
          ? this.input.stepUp()
          : this.input.stepDown();
        if (previousValue !== this.input.value)
          this.input.dispatchEvent(this.changeEvent);
      }

      // Handle direct input changes
      onInputChange() {
        this.validateQtyRules();
      }

      // Validate quantity rules
      validateQtyRules() {
        const value = parseInt(this.input.value);
        const buttonMinus = this.querySelector(
          "[js-flex-bundles-component-quantity-minus]",
        );
        const buttonPlus = this.querySelector(
          "[js-flex-bundles-component-quantity-plus]",
        );

        if (this.input.min) {
          const min = parseInt(this.input.min);
          if (buttonMinus) {
            buttonMinus.disabled = value <= min;
          }
        }
        if (this.input.max) {
          const max = parseInt(this.input.max);
          if (buttonPlus) {
            buttonPlus.disabled = value >= max;
          }
        }
        
        // Also disable input if it exceeds max
        if (this.input.max && value > parseInt(this.input.max)) {
          this.input.value = this.input.max;
        }
      }
    },
  );
}
